<template>
    <div class="epidemicx">
        <div class="epidemicInfo">
            <!-- 健康码 -->
            <div class="codex">
                <div class="codeText"><span class="requiredflag">*</span>1.提交防疫健康码</div>
                <hua-uploader
                    @oversize="oversizeImg"
                    :upload-text="'上传'"
                    :max-count="1"
                    v-model="fileList"
                    preview-size="120px"
                    max-size="10485760"
                    accept="image/*"
                    :after-read="
                        (file) => {
                            afterRead(file, 'healthCode')
                        }
                    "
                />
            </div>
            <hr />
            <!-- 行程码 -->
            <div class="codex">
                <div class="codeText"><span class="requiredflag">*</span>2.提交防疫行程码</div>
                <hua-uploader
                    @oversize="oversizeImg"
                    max-size="10485760"
                    :upload-text="'上传'"
                    :max-count="1"
                    v-model="fileList1"
                    preview-size="120px"
                    accept="image/*"
                    :after-read="
                        (file) => {
                            afterRead(file, 'tripCode')
                        }
                    "
                />
            </div>
        </div>
        <div style="margin: 16px">
            <hua-button :disabled="isDisabled" round block type="primary" @click="changeSteps"
                >下一步</hua-button
            >
        </div>
    </div>
</template>

<script>
import eventBus from '@/constants/eventBus.js'
export default {
    props: {
        isEpidemicInfoRequired: {
            type: Boolean,
        },
        steps: {
            type: Number,
        },
    },
    data() {
        return {
            fileList: [],
            fileList1: [],
            v_travelCodePic: '',
            v_healthCodePic: '',
        }
    },
    computed: {
        isDisabled() {
            if (this.fileList.length && this.fileList1.length) {
                return false
            } else {
                return true
            }
        },
    },

    methods: {
        changeSteps() {
            eventBus.$emit('add', [this.v_healthCodePic, this.v_travelCodePic])
            this.$emit('stepsChange', 1)
        },

        beforeRead(file) {
            if (file.type !== 'image/*') {
                this.$toast('请上传图片文件')
                return false
            }
            return true
        },

        afterRead(file, detail) {
            if (detail.includes('health')) {
                this.v_healthCodePic = file.content
            } else {
                this.v_travelCodePic = file.content
            }
        },
        // 图片大小超过最大限制
        oversizeImg() {
          this.$toast('请上传10M内的图片文件！')
        },
        afterReadFailed(item) {
            setTimeout(() => {
                item.status = 'uploading'
            }, 100)
            setTimeout(() => {
                item.status = 'failed'
                item.message = '上传失败请重新上传'
            }, 500)
        },
    },
}
</script>

<style lang="less">
.epidemicx {
    .epidemicInfo {
        margin: 15px 0;
        padding: 15px;
        background-color: #fff;
        .codex {
            margin-bottom: 12;
            .codeText {
                color: #757575;
                margin-bottom: 12px;
            }
            .requiredflag {
                color: red;
                font-size: 18px;
                margin-right: 3px;
            }
            .hua-uploader__upload-icon {
                top: 12px;
                right: 15px;
            }
            .hua-uploader__upload-text {
                position: relative;
                top: -17px;
                left: 17px;
                font-size: 14px;
                color: #445160;
            }
        }
        hr {
            height: 1px;
            border: none;
            margin-bottom: 15px;
            background-color: #eee;
        }
    }
}
</style>
